import { useEffect, useState } from 'react';
import { Box, Grid, Pagination } from '@mui/material';
import AddressCard from './address-card';
import { Address } from '../../types';
import { useAddressesQuery } from 'app/store';
import SettingsEmptyState from 'components/fallbacks/settings-empty-state';

const PAGE_SIZE = 6;
const SKELETON_COUNT = 3;

const AddressesList = () => {
    const [page, setPage] = useState(1);
    const {
        data: addresses,
        isLoading,
        isError,
    } = useAddressesQuery({
        per_page: PAGE_SIZE,
        page,
    });

    useEffect(() => {
        if (isError && page > 1) {
            setPage(1);
        }
    }, [isError, page]);

    const items = addresses?.items ?? [];
    const totalPages = Math.max(addresses?.pagination?.total_pages ?? 1, 1);
    const isEmpty = !isLoading && !isError && items.length === 0;

    if (isError) {
        return (
            <SettingsEmptyState
                message="دریافت آدرس‌ها با خطا مواجه شد"
                minHeight={340}
            />
        );
    }

    if (isEmpty) {
        return (
            <SettingsEmptyState
                message="هنوز آدرسی برای حساب شما ثبت نشده است"
                minHeight={340}
            />
        );
    }

    return (
        <Box>
            <Grid container spacing={2}>
                {isLoading
                    ? Array.from({ length: SKELETON_COUNT }, (_, index) => (
                          <Grid item xs={12} key={`skeleton-${index}`}>
                              <AddressCard disabled />
                          </Grid>
                      ))
                    : items.map((address: Address) => (
                          <Grid item xs={12} key={address.id}>
                              <AddressCard address={address} />
                          </Grid>
                      ))}
            </Grid>

            {!isLoading && totalPages > 1 && (
                <Box
                    sx={{
                        mt: 2.5,
                        pt: 2.25,
                        display: 'flex',
                        justifyContent: 'center',
                        borderTop: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Pagination
                        count={totalPages}
                        page={Math.min(page, totalPages)}
                        onChange={(_, value: number) => setPage(value)}
                    />
                </Box>
            )}
        </Box>
    );
};

export default AddressesList;
